import { DVIRTemplate } from "../../../models";
import { DVIRTemplateForm } from "../TriplePInterface";

export interface DVIRTemplatePayload {
  data: {
    type: string;
    attributes: {
      name: string;
      description: string;
      is_active: boolean;
      template_type: "pre_trip" | "post_trip" | "end_of_week";
    };
  };
}

export const toDVIRTemplate = (form: DVIRTemplateForm): DVIRTemplatePayload => {
  return {
    data: {
      type: "dvir_templates",
      attributes: {
        name: form.name,
        description: form.description,
        is_active: form.isActive,
        template_type: form.templateType,
      },
    },
  };
};

export interface UpdateDVIRTemplatePayload {
  data: {
    id: string;
    type: string;
    attributes: {
      name: string;
      description: string;
      is_active: boolean;
      template_type: "pre_trip" | "post_trip" | "end_of_week";
    };
  };
}

export const toUpdateDVIRTemplate = (
  template: DVIRTemplate
): UpdateDVIRTemplatePayload => {
  return {
    data: {
      id: template.id,
      type: "dvir_templates",
      attributes: {
        name: template.name,
        description: template.description,
        is_active: template.isActive,
        template_type: template.templateType,
      },
    },
  };
};
